export const flattenDeepArray = <T>(array: (T | (T | T[])[])[]): T[] => {
  return array.reduce<T[]>(
    (acc, val) =>
      Array.isArray(val) ? acc.concat(flattenDeepArray(val as (T | (T | T[])[])[])) : acc.concat(val as T),
    []
  )
}
